import React from "react"
import { StyleSheet, View } from '@react-pdf/renderer'
import { formatInBrazilianDatetime } from "../../../../utils/functions"
import { DataField } from "../../Label"

const styles = StyleSheet.create({
  content: {
    marginTop: 16,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  dataFieldContainer: {
    flex: 1,
  },
  lastUpdatedContainer: {
    // alignItems: 'flex-end',
  },
})

const ScoreWithLastUpdate = ({ bgc_info, score_data }) => {
  const score = score_data && score_data.value ? score_data.value : 0
  const strPoint = score === 1 ? "ponto" : "pontos"
  const strDate = bgc_info?.updated ? formatInBrazilianDatetime(bgc_info?.updated) : 'N/A'

  return (
    <View style={styles.content}>
      <View style={styles.row}>
        <View style={styles.dataFieldContainer}>
          <DataField
            label='Pontuação parcial:'
            value={`${score} ${strPoint}`}
            flexible={false}
          />
          {
            score_data?.reason && <DataField
              label='Motivo da pontuação:'
              value={`${score_data?.reason}`}
              flexible={true}
            />
          }
          <DataField
            label='Última atualização:'
            flexible={false}
            value={strDate}
          />
        </View>
      </View>
    </View>
  )
}

export default ScoreWithLastUpdate
